import { render, staticRenderFns } from "./ProgramCoursesUpdateForm.vue?vue&type=template&id=5784e818"
import script from "./ProgramCoursesUpdateForm.vue?vue&type=script&lang=js"
export * from "./ProgramCoursesUpdateForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports